export class StringUtils {
  public static textHumanize(value: string) {
    return (value || '').replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  }

  public static kebabCase(value: string) {
    return (value || '').replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase());
  }
}
